"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _react = _interopRequireDefault(require("react"));

var _Skeleton = _interopRequireDefault(require("../../Skeleton"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useIsLoading = _interopRequireDefault(require("../LoadingProvider/useIsLoading"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Status = function Status(props) {
  var jobStatus = props.jobStatus;

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  var isLoading = (0, _useIsLoading["default"])();

  if (!jobStatus && !isLoading) {
    return null;
  }

  return (0, _core.jsx)("div", {
    css: /*#__PURE__*/(0, _css2["default"])({
      paddingBottom: 0,
      paddingLeft: spacing(4)
    }, ";label:Status;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9Db250cmFjdC9TdGF0dXMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCUyIsImZpbGUiOiIuLi8uLi8uLi9zcmMvUmVzcG9uc2l2ZUpvYkNhcmQvQ29udHJhY3QvU3RhdHVzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGdW5jdGlvbkNvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IFNrZWxldG9uIGZyb20gJy4uLy4uL1NrZWxldG9uJztcbmltcG9ydCB1c2VUaGVtZSBmcm9tICcuLi8uLi9zdHlsZXMvdXNlVGhlbWUnO1xuaW1wb3J0IFRleHQgZnJvbSAnLi4vLi4vVGV4dCc7XG5cbmltcG9ydCB1c2VJc0xvYWRpbmcgZnJvbSAnLi4vTG9hZGluZ1Byb3ZpZGVyL3VzZUlzTG9hZGluZyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgU3RhdHVzUHJvcHMge1xuICBqb2JTdGF0dXM/OiBzdHJpbmc7XG59XG5cbmNvbnN0IFN0YXR1czogRnVuY3Rpb25Db21wb25lbnQ8U3RhdHVzUHJvcHM+ID0gKHByb3BzKSA9PiB7XG4gIGNvbnN0IHsgam9iU3RhdHVzIH0gPSBwcm9wcztcblxuICBjb25zdCB7IHNwYWNpbmcgfSA9IHVzZVRoZW1lKCk7XG5cbiAgY29uc3QgaXNMb2FkaW5nID0gdXNlSXNMb2FkaW5nKCk7XG5cbiAgaWYgKCFqb2JTdGF0dXMgJiYgIWlzTG9hZGluZykge1xuICAgIHJldHVybiBudWxsO1xuICB9XG5cbiAgcmV0dXJuIChcbiAgICA8ZGl2IGNzcz17eyBwYWRkaW5nQm90dG9tOiAwLCBwYWRkaW5nTGVmdDogc3BhY2luZyg0KSB9fT5cbiAgICAgIDxUZXh0Pntpc0xvYWRpbmcgPyA8U2tlbGV0b24gd2lkdGg9e3NwYWNpbmcoMTYpfSAvPiA6IGpvYlN0YXR1c308L1RleHQ+XG4gICAgPC9kaXY+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBTdGF0dXM7XG4iXX0= */"))
  }, (0, _core.jsx)(_Text["default"], null, isLoading ? (0, _core.jsx)(_Skeleton["default"], {
    width: spacing(16)
  }) : jobStatus));
};

__signature__(Status, "useTheme{{ spacing }}\nuseIsLoading{isLoading}", function () {
  return [_useTheme2["default"], _useIsLoading["default"]];
});

var _default = Status;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Status, "Status", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/Status.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/Status.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();